import { Line3, Vector3 } from 'three'

export const CAD_CURVE_MAX_ERROR = 0.002
export const CAD_SPLINE_MAX_SEGMENTS = 8192

/**
 * 在节点区间内依据四分点到弦的距离自适应细分；保留端点并限制总段数。
 * seedParameters 应包含节点边界，避免跨越不连续曲率段漏检。
 */
export function sampleCurveByFlatness(
  evaluate: (parameter: number) => Vector3,
  seedParameters: readonly number[],
  maxError = CAD_CURVE_MAX_ERROR,
  maxSegments = CAD_SPLINE_MAX_SEGMENTS
): Vector3[] {
  const parameters = [...new Set(seedParameters)].sort((a, b) => a - b)
  if (parameters.length < 2) return parameters.map(evaluate)
  const points: Vector3[] = [evaluate(parameters[0]!)]
  const chord = new Line3()
  const closest = new Vector3()
  let segments = parameters.length - 1
  const append = (start: number, end: number, a: Vector3, b: Vector3, depth: number) => {
    const middle = (start + end) / 2
    const midPoint = evaluate(middle)
    chord.set(a, b)
    const deviations = [evaluate((start + middle) / 2), midPoint, evaluate((middle + end) / 2)]
    const needsSplit = deviations.some((point) => {
      chord.closestPointToPoint(point, true, closest)
      return point.distanceToSquared(closest) > maxError * maxError
    })
    if (needsSplit && segments < maxSegments && depth < 20) {
      segments += 1
      append(start, middle, a, midPoint, depth + 1)
      append(middle, end, midPoint, b, depth + 1)
    } else {
      points.push(b)
    }
  }
  for (let index = 0; index + 1 < parameters.length; index += 1) {
    const start = parameters[index]!
    const end = parameters[index + 1]!
    append(start, end, points[points.length - 1]!, evaluate(end), 0)
  }
  return points
}
